import client from './client';

export const listTickets = (params) => client.get('/api/department/tickets', { params });
export const getTicket = (id) => client.get(`/api/department/tickets/${id}`);
export const postTicketMessage = (ticketId, payload) => client.post(`/api/department/tickets/${ticketId}/messages`, payload);
export const updateTicket = (ticketId, payload) => client.patch(`/api/department/tickets/${ticketId}`, payload);

export default {
  listTickets,
  getTicket,
  postTicketMessage,
  updateTicket,
};
